import { useState, useEffect, useCallback } from "react";
import { Link, useLocation } from "react-router-dom";
import Layout from "@/components/Layout";
import { getCasinoGameDetails, getMatchExposure, getLastResults, getDetailResults } from "@/services/casinoApi";
import BetTableTeenPatti20c from "../components/teen20c/BetTableTeenPatti20c";
import ResultTeen20c from "../components/teen20c/ResultTeen20c";
import RightSection from "../components/RightSection/RightSection";
import styles from "./TeenPatti20c.module.css";
import VideoBox from "../components/common/VideoBox";
import CasinoHeading from "../components/common/CasinoHeading";

function extractCasinoGame(url) {
  const match = url.match(/\/lord-games\/([^/?#]+)/);
  return match ? match[1] : null;
}

export default function TeenPatti20c() {
  const [gameData, setGameData] = useState({});
  const [activeTab, setActiveTab] = useState("game");
  const [iframeSrc, setIframeSrc] = useState("");
  const { pathname } = useLocation();
  const [playerAData, setPlayerAData] = useState([]);
  const [playerBData, setPlayerBData] = useState([]);
  const [exposures, setExposures] = useState({});
  const [myBets, setMyBets] = useState([]);

  useEffect(() => {
    const name = extractCasinoGame(pathname) || "teen20c";
    setIframeSrc(`https://casino-stream.softgamingapi.com/casino-tv?id=${name}`);

    const fetchGameData = async () => {
      try {
        const response = await getCasinoGameDetails(name);
        setGameData(response);
      } catch (err) {
        console.error("Error fetching game data:", err);
      }
    };

    fetchGameData();
    const interval = setInterval(fetchGameData, 1500);
    return () => clearInterval(interval);
  }, [pathname]);

  useEffect(() => {
    const subData = gameData?.data?.data?.sub || [];
    if (Array.isArray(subData) && subData.length > 0) {
      setPlayerAData(subData.filter(item => item.nat?.endsWith("A")));
      setPlayerBData(subData.filter(item => item.nat?.endsWith("B")));
    }
  }, [gameData?.data?.data?.sub]);

  const fetchExposure = useCallback(async () => {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const userId = user?.user_id || user?.id;
      const matchId = gameData?.data?.data?.mid?.toString();

      if (userId && matchId) {
        const response = await getMatchExposure(userId, matchId);
        if (response.success && response.data) {
          const exposureMap = {};
          response.data.forEach((item) => {
            exposureMap[item.team_name] = parseFloat(item.exposure_amount) || 0;
          });
          setExposures(exposureMap);
        }
      }
    } catch (error) {
      console.error('Error fetching exposure:', error);
    }
  }, [gameData?.data?.data?.mid]);

  useEffect(() => {
    const matchId = gameData?.data?.data?.mid?.toString();
    if (!matchId) return;

    const timeoutId = setTimeout(() => {
      fetchExposure();
    }, 2000);

    const intervalId = setInterval(() => {
      fetchExposure();
    }, 2000);

    return () => {
      clearTimeout(timeoutId);
      clearInterval(intervalId);
    };
  }, [gameData?.data?.data?.mid, fetchExposure]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const handleBetClick = (value, selection, betData, tablePlayerName) => {
    // Betting functionality can be added later
    console.log("Bet clicked:", { value, selection, betData, tablePlayerName });
  };

  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.sectionA}>
          <CasinoHeading
            name="20-20 TEENPATTI C"
            roundId={gameData?.data?.data?.mid || "157250124095658"}
            placedBetCount={myBets.length}
            activeTab={activeTab}
            onTabChange={handleTabChange}
          />

          {activeTab === "game" && (
            <>
              <VideoBox
                gameType="teen20c"
                resultData={gameData?.data?.data?.card}
                iframeSrc={iframeSrc}
                timerValue={gameData?.data?.data?.lt}
              />

              <div className={styles.tableContainer}>
                <div className={styles.tableWrapper}>
                  <BetTableTeenPatti20c
                    data={playerAData}
                    onBetClick={(value, selection, betData) => handleBetClick(value, selection, betData, "A")}
                    playerName="A"
                    exposures={exposures}
                    myBets={myBets}
                  />
                </div>
                <div className={styles.tableWrapper}>
                  <BetTableTeenPatti20c
                    data={playerBData}
                    onBetClick={(value, selection, betData) => handleBetClick(value, selection, betData, "B")}
                    playerName="B"
                    exposures={exposures}
                    myBets={myBets}
                  />
                </div>
              </div>
              <div className={styles.heading}>
                <div>Last Result</div>
                <Link to="/admin/reports/casinoresult/teen20c">
                  <div className={styles.viewAll}>View All</div>
                </Link>
              </div>
              <ResultTeen20c
                data={gameData?.lrs || []}
                gameData={gameData}
              />
            </>
          )}

        </div>

        <RightSection
          sectionKey="teen20c"
          data={myBets}
          title="Matched"
          viewMoreText="View More"
          onViewMore={() => {
            // Handle view more action
            console.log("View more clicked for teen20c");
          }}
        />
      </div>
    </Layout>
  );
}
